import { styled } from "@mui/material";
import { RosebudColorMap } from "../../rosebud/rosebudColorMap";
import { KahunColorMap } from "fe-common/ui/assets/colorMap";

import CloseIcon from "@mui/icons-material/Close";

export const ClearIcon = styled(CloseIcon)({
  cursor: "pointer",
  color: RosebudColorMap.gray2,
  opacity: 0.5,
  "&:hover": {
    color: KahunColorMap.Accent,
  },
  marginLeft: "auto",
  marginRight: "10px",
  alignSelf: "center",
});
